import { useQuery } from '@tanstack/react-query';
import { getTourStats } from '../Services/Tours.service';
import { toursQueryKeys } from '../Constants/queryKeys';

export const useTourStats = (tourId: string | null) => {
  const query = useQuery({
    queryKey: toursQueryKeys.stats(tourId ?? ''),
    queryFn: () => getTourStats(tourId ?? ''),
    enabled: !!tourId,
  });

  return {
    stats: query.data ?? null,
    isLoading: query.isLoading,
    error: query.error?.message ?? null,
  };
};
